<div class="modal-header glc-modal-header">
  <div class="glc-header-icon">
    <i class="fa-solid" [ngClass]="platformSrv.platform.getIsExam() ? 'fa-lightbulb' : 'fa-globe'"></i>
  </div>
  <div class="glc-header-body">
    <div class="glc-header-title">
      <span *ngIf="!platformSrv.platform.getIsExam()" translate>Cultures</span>
      <span *ngIf="platformSrv.platform.getIsExam()" translate>Conseils</span>
    </div>
    <div class="glc-header-sub">{{ level?.name }}</div>
  </div>
  <button type="button" class="glc-close-btn" (click)="close()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<div class="modal-body glc-modal-body">

  <app-spinner *ngIf="loader"></app-spinner>

  <ng-container *ngIf="!loader">

    <div class="glc-count-label">
      <i class="fa-solid fa-layer-group"></i>
      {{ cultures.length }}
      <span *ngIf="!platformSrv.platform.getIsExam()" translate>point(s) culture</span>
      <span *ngIf="platformSrv.platform.getIsExam()" translate>conseil(s)</span>
    </div>

    <div class="glc-list">
      <app-culture-item *ngFor="let culture of cultures; trackBy: trackById" [culture]="culture"></app-culture-item>
    </div>

  </ng-container>

</div>
